"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, FlexCenter, SkeletonBlock, SpaceBetween, Switch, TextBody } from "@opensea/ui-kit";
import { useLocalStorage } from "@opensea/ui-kit/hooks";
import { useTranslations } from "use-intl";
import { CREATOR_FEE_ENFORCED_LOCAL_STORAGE } from "../../flow/BottomSheetFlows/constants";
export const CreatorEarningsToggle = t0 => {
  const $ = _c(15);
  const {
    creatorFeeEnforced,
    checked,
    onCheckedChange,
    disabled
  } = t0;
  const t = useTranslations("wallet.CreatorEarningsToggle");
  const [, setCreatorFeeEnforced] = useLocalStorage(CREATOR_FEE_ENFORCED_LOCAL_STORAGE, true);
  let t1;
  if ($[0] !== onCheckedChange || $[1] !== setCreatorFeeEnforced) {
    t1 = checked_0 => {
      onCheckedChange?.(checked_0);
      setCreatorFeeEnforced(checked_0);
    };
    $[0] = onCheckedChange;
    $[1] = setCreatorFeeEnforced;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onChange = t1;
  const isChecked = creatorFeeEnforced ? true : checked;
  const t2 = creatorFeeEnforced || disabled;
  let t3;
  if ($[3] !== isChecked || $[4] !== onChange || $[5] !== t2) {
    t3 = <Switch checked={isChecked} disabled={t2} onCheckedChange={onChange} />;
    $[3] = isChecked;
    $[4] = onChange;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isChecked || $[8] !== t) {
    t4 = isChecked ? t("on") : t("off");
    $[7] = isChecked;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <TextBody className="uppercase" color="text-secondary">{t4}</TextBody>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <FlexCenter className="gap-2">{t3}{t5}</FlexCenter>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export const CreatorEarningsToggleSkeleton = t0 => {
  const $ = _c(10);
  const {
    className
  } = t0;
  const t = useTranslations("wallet.CreatorEarningsToggle");
  let t1;
  if ($[0] !== className) {
    t1 = classNames("py-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("creatorEarnings");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <TextBody weight="semibold">{t2}</TextBody>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SkeletonBlock className="h-6 w-12 rounded-full" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t3) {
    t5 = <SpaceBetween className={t1}>{t3}{t4}</SpaceBetween>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};